'use strict'

import React from 'react';
import {FilterOptions} from '../Filter.jsx';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
  require('./labels/english.js'),
  require('./labels/norwegian.js')
])

const request=require('superagent');

const options={
  time: [
    {id: "lessThan12Months"},
    {id: "oneToThreeYears"},
    {id: "threeToFiveYears"},
    {id: "moreThanFiveYears"}
  ]
};

export default class LessonFilterAdvanced extends React.Component {
  constructor(props) {
    super(props);
    this.state={loading:true, keywords:""};
  }

  //TODO: Copied form Filter.jsx
  pluralName(propertyName) {
    return propertyName.slice(-1)==="y" ? propertyName.slice(0,-1)+"ies" : propertyName+"s";
  }

  updateOptions(availableFilters) {
    var filter={};
    ["started", "paused","stopped","completed"].forEach(value=>filter["state_"+value]=true);
    (this.props.limitToPortfolio!==undefined ? [] : ["portfolio"])
      .concat(["location", "projectType", "department", "category"]).forEach(property=>{
        if (availableFilters[this.pluralName(property)]!==undefined && availableFilters[this.pluralName(property)].length>0) {
          availableFilters[this.pluralName(property)].forEach(item=>filter[property+"_"+item.id]=true)
        }
      })

    if (this.props.limitToPortfolio!==undefined) {
      filter["portfolio_"+this.props.limitToPortfolio]=true;
    }

    Object.keys(options).forEach(property=>options[property].forEach(key=>filter[property+"_"+key.id]=true));
    this.setState({loading:false, tenant: availableFilters, filter: filter});
  }

  componentWillMount(props) {
    request
      .get("/lessons/filterOptions")
      .then(response=>this.updateOptions(JSON.parse(response.text).tenant))
      .catch(error=>{
        console.log("[ERROR] Not able to load filter options, got",error);
        this.setState({loading:false, error:error.message})
      })
  }

  changeProperty(property,key,value) {
    const updatedFilter=Object.assign({},this.state.filter,{
      [property+"_"+key]: value
    });
    this.setState(
      {filter: updatedFilter},
      ()=>this.props.onChange(updatedFilter,this.state.keywords)
    );
  }

  changedKeywords(event) {
    event.preventDefault();
    const newKeywords=event.target.value;
    this.setState(
      {keywords: newKeywords},
      ()=>this.props.onChange(this.state.filter,newKeywords)
    );
  }

  render() {
    let labels=translations.getTranslation(this.props).general.lessons;
    const optionsWithTranslation=Object.keys(options)
      .reduce((object,key)=>Object.assign({},object,{
        [key]:options[key].map(value=>({
          id: value.id,
          name: labels.filterOptions!==undefined
            ? labels.filterOptions[key]!==undefined
              ? labels.filterOptions[key].options!==undefined && labels.filterOptions[key].options[value.id]!==undefined
                ? labels.filterOptions[key].options[value.id]
                : "(."+key+"."+value.id+")"
              : "(."+key+", missing option"+value.id+")"
            : "(."+key+", missing filterOptions)"
        }))
      }),
      {}
    );

    return (this.state.loading===true) ? (
      <div>
        <i>...loading search options</i>
      </div>
    ) : this.state.error!==undefined ? (
      <div style={{marginTop: 10, padding:10, backgroundColor: "lightyellow", border:"solid 1px brown", color: "red"}}>
        <b>An error occured</b>: {this.state.error}
      </div>
    ) : (
      <div style={{paddingTop: 10, paddingLeft:20}}>
        <FilterOptions
          exclude={this.props.limitToPortfolio!==undefined ? ["portfolio"] : undefined}
          filter={[]}
          tenant={this.state.tenant}
          options={optionsWithTranslation}
          onChange={this.changeProperty.bind(this)}
          filter={this.state.filter}
        />
        <div>
          {labels.keywords.title}:
          <span> </span>
          <input onChange={this.changedKeywords.bind(this)} size="40" placeholder={labels.keywords.description} value={this.state.keywords}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/plan/LessonFilterAdvanced.jsx